import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { format, subDays } from 'date-fns'
import { apiService, Restock } from '../..'
import { orderStatistics, Statistics } from './types'
import { Stores } from '../stores/types'

export class MainService {
  static getStatistics(
    storeId: string,
    days: number,
  ): Promise<AxiosResponse<Statistics>> {
    return apiService.get<AxiosResponse<Statistics>>(
      `/stores/${storeId}/statistics`,
      { params: { days } },
    )
  }

  static getOrderStatistics(
    storeId: string,
    days: number,
  ): Promise<AxiosResponse<orderStatistics>> {
    if (!Number.isInteger(days) || days < 1 || days > 366) {
      return Promise.reject(
        new RangeError('Statistics period must be between 1 and 366 days'),
      )
    }

    const dateTo = new Date()
    const dateFrom = format(subDays(dateTo, days - 1), 'yyyy-MM-dd')
    return apiService.get<AxiosResponse<orderStatistics>>(
      `/stats/count-orders?storeId=${storeId}&dateFrom=${dateFrom}&dateTo=${format(dateTo, 'yyyy-MM-dd')}`,
    )
  }

  static getRestock(storeId: string): Promise<AxiosResponse<Restock[]>> {
    return apiService.get<AxiosResponse<Restock[]>>(
      `/products/restock?store_id=${storeId}`,
    )
  }

  static getStores(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Stores[]>> {
    return apiService.get<AxiosResponse<Stores[]>>(`/stores`, config)
  }
}
